import { render, staticRenderFns } from "./App.vue?vue&type=template&id=51894be0&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51894be0",
  null
  
)

export default component.exports